module.exports = __webpack_public_path__ + "static/media/player-avatar-99.a9f8af81.png";